export default {
    methods: {
        showTicketPhaseActionError() {
            swal.fire(
                'Cannot complete action!',
                'Selected phase has attached tickets',
                'error'
            );
        },
        checkPhaseHasTickets(phase) {
            return phase.tickets_count > 0
        },
        removePhaseFromList(phase) {
            let index = this.teamTicketPhases.indexOf(phase);

            if (index !== -1) {
                this.teamTicketPhases.splice(index, 1);
                this.decrementPhaseOrders(phase);
            }
        },
        decrementPhaseOrders(phase) {
            this.teamTicketPhases.forEach((ticketPhase, index) => {
                if(ticketPhase.order > phase.order) {
                    this.teamTicketPhases[index].order = --ticketPhase.order;
                }
            });
        },
        resetPhaseOrders() {
            this.teamTicketPhases.forEach((ticketPhase, index) => {
                this.teamTicketPhases[index].order = ++index;
            })
        },
        fetchTicketPhases(setDefaultPhase) {
            axios.get(`settings/tickets/phases`)
            .then(response => {
                this.ticketPhases = response.data;

                if(setDefaultPhase && this.ticketPhases.length > 0) {
                    this.form.phase_id = _.head(this.ticketPhases).id;
                }
            });
        }
    }
}
